import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'portal-file-upload-download',
  templateUrl: './file-upload-download.component.html',
  styles: [],
  standalone: false,
})
export class FileUploadDownloadComponent {
  @Input()
  accept: string;

  @Input()
  downloadUrl?: string;

  @Input()
  fileName?: string;

  @Input()
  info: string;

  @Input()
  removing: boolean;

  @Input()
  required: boolean = false;

  @Output()
  fileChanged = new EventEmitter<File>();

  @Output()
  removeFile = new EventEmitter<void>();

  file?: File;

  get invalid(): boolean {
    return this.required === true && this.file == null;
  }

  get isNew(): boolean {
    return this.downloadUrl == null;
  }

  clearSelectedFile(): void {
    this.file = null;
  }

  delete() {
    this.removeFile.emit();
  }

  setFile(file: File) {
    this.file = file;

    this.fileChanged.emit(file);
  }
}
